<template>
  <div class="moon-image mb-3">
    <div v-if="phase.indexOf('Полнолуние') > -1">
      <img src="../../assets/moon/fullmoon.png" />
    </div>
    <div v-else-if="phase.indexOf('Новолуние') > -1">
      <img src="../../assets/moon/newmoon.png" />
    </div>
    <div v-else>
      <img v-if="quarter === 'первая фаза'" src="../../assets/moon/0.png" />
      <img v-if="quarter === 'вторая фаза'" src="../../assets/moon/1.1.png" />
      <img v-if="quarter === 'третья фаза'" src="../../assets/moon/3.png" />
      <img v-if="quarter === 'четвертая фаза'" src="../../assets/moon/4.1.png" />

      <img v-if="quarter === 'первая четверть'" src="../../assets/moon/1.png" />
      <img v-if="quarter === 'третья четверть'" src="../../assets/moon/4.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MoonImage",
  props: ["quarter", "phase"],
}
</script>

<style lang="scss" scoped>
.moon-image {
  img {
    //width: 130px;
    height: auto;
  }
}
</style>